import { BACKEND_URL } from "../env";
import { AppIntegrityReport } from "../types/app-integrity";

/** Fetches the live per-app integrity report. Returns null on any failure. */
export async function fetchAppIntegrity(
  appId: string
): Promise<AppIntegrityReport | null> {
  try {
    const response = await fetch(
      `${BACKEND_URL}/admin/apps/${appId}/integrity`,
      { credentials: "include", cache: "no-store" }
    );

    if (response.status >= 400) {
      return null;
    }

    return (await response.json()) as AppIntegrityReport;
  } catch {
    return null;
  }
}
